export enum CalculationStatus {
  NONE = 0,
  PENDING = 1,
  RUNNING = 2,
  SUCCESS = 3,
  FAILED = 4
}

export enum DataTotalBaseType {
  BUDGET = 0,
  KPI = 1,
  KPI_AND_BUDGET_BOTH = 2,
}

export enum DataTotalSource {
  MANUAL = 0,
  OPTIMIZATION = 1,
}
